import React, { useState, memo, useEffect, Fragment } from 'react';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { LemsAPI } from '../../common/utils/api-utils';
import { useForceRerender } from '../../hooks/useForceRender';
import { getCompanyDetailsInPrincple } from '../../common/constants/api';
import styles from '../../containers/CMDashboard/CMDashboard.module.css';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import CircularLoading from '../../common/components/CircularLoading/CircularLoading';
const { professional_data, applicantHeading } = styles;

export const CardHeading = ({ heading }) => (
  <div className={`block mt-4 ${professional_data}  `}>
    <p className="text-green-800 font-roboto font-semibold text-md ">
      {heading}
    </p>
  </div>
);
export const ApplicantHeading = ({ heading }) => (
  <div
    className={`block  mt-4 ${applicantHeading} py-2  `}
    style={{
      width: 'fit-content'
    }}
  >
    <p className="text-black-400 font-roboto font-semibold text-md text-center">
      {heading}
    </p>
  </div>
);

const CompanyDetails = () => {
  const [companyDetails, setCompanyDetails] = useState([]);
  const [isGetOver, setIsGetOver] = useState(false);

  useEffect(() => {
    setIsGetOver(false);
    getCompanyDetailsInPrincple(getApplicantionInfo().leadId).then(res => {
      setCompanyDetails(res);
      setIsGetOver(true);
    });
  }, []);

  if (isGetOver) {
    if (companyDetails.length > 0) {
      return companyDetails.map((el, i) => (
        <Fragment key={i}>
          {i === 0 ? (
            <ApplicantHeading heading="Main Applicant" />
          ) : (
            <ApplicantHeading heading={`Co-applicant ${i}`} />
          )}
          <div className="w-full bg-white my-3 capitalize ">
            <div className="w-full px-4 py-6  bg-white shadow-md  rounded-md border border-grey-1009">
              <CardHeading heading="self employed Details" />
              <div className={`w-12/12 flex flex-wrap justify-start `}>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    company Type
                  </p>
                  <p className="text-black-400 font-roboto  font-medium ">
                    {el?.selfEmployedDetails?.companyType || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Company Name
                  </p>
                  <p className="text-black-400 font-roboto  font-medium ">
                    {el?.selfEmployedDetails?.companyName || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm uppercase">
                    CIN
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {el?.selfEmployedDetails?.cin || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Nature of business
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {el?.selfEmployedDetails?.natureOfBusiness?.name || 'NA'}
                  </p>
                </div>

                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Industry
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {el?.selfEmployedDetails?.industry?.name || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Sub-Industry
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {el?.selfEmployedDetails?.subIndustry?.name || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Company Pan card
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {el?.selfEmployedDetails?.companyPan || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Gst no
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {el?.selfEmployedDetails?.gstNumber || 'NA'}
                  </p>
                </div>
              </div>

              {/* business address  */}
              <CardHeading heading="Business address" />

              <div className={`w-12/12 flex flex-wrap justify-start `}>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Address
                  </p>
                  <p className="text-black-400 font-roboto  font-medium break-words ">
                    {el?.businessAddress?.address?.line1
                      ? el?.businessAddress?.address?.line1
                      : ''}
                    &nbsp;
                    {el?.businessAddress?.address?.line2
                      ? el?.businessAddress?.address?.line2
                      : ''}
                    &nbsp;
                    {el?.businessAddress?.address?.city
                      ? el?.businessAddress?.address?.city
                      : ''}
                    &nbsp;
                    {el?.businessAddress?.address?.state
                      ? el?.businessAddress?.address?.state
                      : ''}
                    &nbsp;
                    {el?.businessAddress?.address?.pincode
                      ? el?.businessAddress?.address?.state
                      : ''}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Area code
                  </p>
                  <p className="text-black-400 font-roboto  font-medium ">
                    {el?.businessAddress?.areaCode || 'NA'}
                  </p>
                </div>
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    registration Number
                  </p>
                  <p className="text-black-400 font-roboto  font-medium ">
                    {el?.businessAddress?.registrationNumber || 'NA'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ));
    } else {
      return (
        <div
          className="absolute inset-x-3/10 mt-20 text-black-1003 text-base font-medium"
          style={{ width: 'fit-content' }}
        >
          No Documents Available. .
        </div>
      );
    }
  } else {
    return <CircularLoading />;
  }
};
export default memo(withErrorHandler(CompanyDetails, LemsAPI));
